import type { SalesPeriod, SalesPeriodPayload } from './types';

export async function fetchSalesPeriod(
  period: SalesPeriod,
  sid: number | null,
): Promise<SalesPeriodPayload> {
  const q = new URLSearchParams({ period });
  if (sid !== null) q.set('sid', String(sid));
  const res = await fetch('/api/sales-period?' + q.toString(), {
    credentials: 'same-origin',
  });
  if (!res.ok) throw new Error(await res.text());
  return (await res.json()) as SalesPeriodPayload;
}
